import { ListEntity } from "models/list-entity";

export const findFieldByIdentifier = (
  listEntities: ListEntity[],
  identifier: string,
) => {
  for (let i = 0; i < listEntities.length; i += 1) {
    const { listEntityFields = [] } = listEntities[i];
    for (let x = 0; x < listEntityFields.length; x += 1) {
      if (identifier === listEntityFields[x].identifier) {
        return listEntityFields[x];
      }
    }
  }
  return undefined;
};
